import { TabsMenu } from "components/CustomTabs";
import PageHeader from "components/PageHeader";
import PackageList from "features/LoyaltyPackage/presentation/pages/PackageList";
import ProgramList from "features/LoyaltyPackage/presentation/pages/ProgramList";
import { LOYALTY_TAB_KEY } from "features/LoyaltyPackage/core/constants";
import { t } from "i18next";
import { useCallback, useEffect, useState } from "react";
import { buildQueryString, getQuery } from "utils/helperFuncs";

import "./index.scss";

function resolveTabFromUrl() {
  const tab = getQuery()?.tab;
  return tab === LOYALTY_TAB_KEY.PACKAGE ? LOYALTY_TAB_KEY.PACKAGE : LOYALTY_TAB_KEY.PROGRAM;
}

function LoyaltyPackageList() {
  const [activeTab, setActiveTab] = useState(resolveTabFromUrl);

  useEffect(() => {
    const onPopState = () => setActiveTab(resolveTabFromUrl());
    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, []);

  const handleTabChange = useCallback((key) => {
    setActiveTab(key);
    if (key === LOYALTY_TAB_KEY.PROGRAM) {
      window.history.pushState(null, "", window.location.pathname);
    } else {
      buildQueryString({ params: { tab: key } });
    }
  }, []);

  const tabs = [
    {
      title: t("loyaltyPackage.tabProgram"),
      key: LOYALTY_TAB_KEY.PROGRAM,
      children: <ProgramList />,
    },
    {
      title: t("loyaltyPackage.tabPackage"),
      key: LOYALTY_TAB_KEY.PACKAGE,
      children: <PackageList />,
    },
  ];

  return (
    <>
      <PageHeader pageTitle={t("loyaltyPackage.title")} />
      <div className="loyalty-package-container">
        <TabsMenu activeKey={activeTab} tabs={tabs} onChange={handleTabChange} destroyInactiveTabPane />
      </div>
    </>
  );
}

export default LoyaltyPackageList;
